<app-menu-buttons-page
  label="Normas de la casa"
  [topActions]="topActions"
  [backgroundImage]="backgroundImage"
  (actionClick)="onActionClick($event)"

>
</app-menu-buttons-page>
